import { HttpClientTestingModule } from '@angular/common/http/testing';

import { initialModule, ModuleMetadata } from '../base/initial-module';

import { SpecHttpOptions } from './options';

/**
 * @internal
 */
export function initialHttpModule<S>(options: Required<SpecHttpOptions<S>>): ModuleMetadata {
  const moduleMetadata = initialModule(options);

  moduleMetadata.providers.push(options.service);
  moduleMetadata.imports.push(HttpClientTestingModule);

  return moduleMetadata;
}
